// components/SchedulerVisits.jsx
import React from 'react';
import { useSchedule } from '../hooks/useSchedule';
import { ScheduleRow } from './ScheduleRow';
import schema from '../forms/schema.json';

const { title, description, properties } = schema;

export const SchedulerVisits = ({ kgId, onClose }) => {
  const {
    schedule,
    loading,
    error,
    updateActive,
    updateTime,
    saveSchedule,
    clearError
  } = useSchedule(kgId, onClose);


  return (
    <div className="container-fluid p-0">
      <div className="mb-4">
        <h3 className="h4 mb-2">{title}</h3>
        <p className="text-muted mb-0">{description}</p>
      </div>

      {error && (
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
          {error}
          <button
            type="button"
            className="btn-close"
            onClick={clearError}
            aria-label="Close"
          />
        </div>
      )}

      <div className="table-responsive mb-4">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>День тижня</th>
              <th>Активний</th>
              <th>Час прийому</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(properties).map((key) => (
              <ScheduleRow
                key={key}
                dayKey={key}
                title={properties[key].title}
                schedule={schedule[key]}
                onActiveChange={updateActive}
                onTimeChange={updateTime}
              />
            ))}
          </tbody>
        </table>
      </div>

      <div className="d-flex gap-3 justify-content-end">
        <button
          className="btn btn-primary"
          onClick={saveSchedule}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Збереження...
            </>
          ) : (
            'Зберегти'
          )}
        </button>
        <button
          className="btn btn-secondary"
          onClick={onClose}
          disabled={loading}
        >
          Закрити
        </button>
      </div>
    </div>
  );
};